import { FiMinus } from "react-icons/fi";
import { GoPlus } from "react-icons/go";

const Accordion = ({ outerText, onClick, compare, open, innerText }) => {
  return (
    <div className="p-2 bg-white shadow-sm rounded-lg border-[1px] border-[#dedddd]">
      <div onDoubleClick={onClick} className="  flex justify-between items-center ">
        <div className="sm:text-[1.125rem] text-sm font-semibold  ">
          {outerText}
        </div>
        <div className="sm:text-3xl text-xl " onClick={onClick}>
          {compare ? <GoPlus /> : open ? <FiMinus /> : <GoPlus />}
        </div>
      </div>
      <div
        className={`${
          compare ? "hidden" : open ? "block" : "hidden"
        } border-t-[1px] m-2 p-3 text-[#758495]`}
      >
        <div>{innerText()}</div>
      </div>
    </div>
  );
};

export default Accordion;
